import axios from "axios";
import { REACT_APP_API_URL } from "../api/global";

export const fetchFreeVotes = (token) => async (dispatch) => {
  dispatch({ type: "FETCH_FREE_VOTE_REQUEST" });

  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/getFreeVotes`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    dispatch({ type: "FETCH_FREE_VOTE_SUCCESS", payload: response.data });
  } catch (error) {
    dispatch({ type: "FETCH_FREE_VOTE_FAILURE", payload: error.message });
  }
};
